import { Result, Button } from 'antd'
import { useTranslation } from 'react-i18next'

interface ErrorFallbackProps {
  error: Error | string
  onRetry?: () => void
}

export default function ErrorFallback({ error, onRetry }: ErrorFallbackProps) {
  const { t } = useTranslation()
  const message = typeof error === 'string' ? error : error.message

  return (
    <Result
      status="error"
      title={t('errorOccurred')}
      subTitle={message}
      extra={
        onRetry && (
          <Button type="primary" onClick={onRetry}>
            {t('retry')}
          </Button>
        )
      }
    />
  )
}
